export const CITY_SELECT_COPY = {
  label: "City",
  requiredError: "Select a city",
} as const;
